/**
 * @name: memberManagement.js
 * @description: 会员管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/member/customer/list',
    name: 'customerManagement',
    component: () => import('@/views/member/customer/List'),
    meta: {
      title: '客户管理'
    }
  },
  {
    path: '/member/customer/record',
    name: 'record',
    component: () => import('@/views/member/customer/Record'),
    meta: {
      title: '客户访问记录',
      parentRoutePath: 'customerManagement'
    }
  },
  {
    path: '/member/distributor/list',
    name: 'distributorManagement',
    component: () => import('@/views/member/distributor/List'),
    meta: {
      title: '分销员管理'
    }
  },
  {
    path: '/member/distributor/detail',
    name: 'distributorDetail',
    component: () => import('@/views/member/distributor/Detail'),
    meta: {
      title: '分销员详情',
      parentRoutePath: 'distributorManagement'
    }
  },
];
